// Domande del questionario Metodo BDF Assessment
// Suddivise per ruolo: danzatore, insegnante, entrambi

export const SCALE_LABELS = [
  { value: 1, label: "Mai" },
  { value: 2, label: "Raramente" },
  { value: 3, label: "A volte" },
  { value: 4, label: "Spesso" },
  { value: 5, label: "Sempre" },
];

// ============ DANZATORE: 16 domande ============
const DANZATORE_QUESTIONS = [
  // Consapevolezza Respiratoria
  { id: 1, area: "consapevolezza", text: "Durante una lezione o un allenamento sei consapevole di come stai respirando?" },
  { id: 2, area: "consapevolezza", text: "Ti accorgi quando il tuo respiro diventa superficiale o accelerato?" },
  { id: 3, area: "consapevolezza", text: "Utilizzi volontariamente il respiro per migliorare la qualità del movimento?" },
  { id: 4, area: "consapevolezza", text: "Ritieni che la respirazione influenzi direttamente la performance nella danza?" },
  // Performance e Recupero
  { id: 5, area: "performance_recupero", text: "Durante lezioni intense o prove lunghe ti capita di rimanere senza fiato?" },
  { id: 6, area: "performance_recupero", text: "Ti senti stanco prima della fine della lezione o della prova?" },
  { id: 7, area: "performance_recupero", text: "Dopo una sequenza intensa recuperi rapidamente il respiro?" },
  { id: 8, area: "performance_recupero", text: "Riesci a mantenere qualità tecnica ed espressiva anche quando sei affaticato?" },
  // Gestione Ansia
  { id: 9, area: "gestione_ansia", text: "Prima di un esame, audizione o spettacolo provi ansia o agitazione?" },
  { id: 10, area: "gestione_ansia", text: "Quando sei sotto pressione senti il respiro modificarsi?" },
  { id: 11, area: "gestione_ansia", text: "Sai utilizzare il respiro per calmarti nei momenti di stress?" },
  { id: 12, area: "gestione_ansia", text: "Ti senti mentalmente presente e concentrato durante la performance?" },
  // Applicazione Tecnica / Presenza Scenica
  { id: 13, area: "applicazione_tecnica", text: "Quanto ti senti sicuro nell'applicare la respirazione durante adagi, equilibri, pirouette e salti?" },
  { id: 14, area: "applicazione_tecnica", text: "Quanto integri la respirazione per migliorare espressività, musicalità e presenza scenica?" },
  { id: 15, area: "applicazione_tecnica", text: "Sai coordinare il respiro durante adagi e movimenti lenti?" },
  { id: 16, area: "applicazione_tecnica", text: "Ritieni che il respiro possa migliorare espressività e presenza scenica?" },
];

// ============ INSEGNANTE: 18 domande ============
const INSEGNANTE_QUESTIONS = [
  // Pratica didattica
  { id: 101, area: "pratica_didattica", text: "Spieghi regolarmente ai tuoi allievi come utilizzare il respiro nella danza?" },
  { id: 102, area: "pratica_didattica", text: "Utilizzi già esercizi respiratori durante le tue lezioni?" },
  { id: 103, area: "pratica_didattica", text: "Ti senti sicuro nell'insegnare tecniche respiratorie ai tuoi allievi?" },
  { id: 104, area: "pratica_didattica", text: "Ti senti sicuro nel correggere la respirazione dei tuoi allievi?" },
  { id: 113, area: "pratica_didattica", text: "Riesci a riconoscere quando un allievo utilizza una respirazione inefficiente durante la lezione?" },
  { id: 114, area: "pratica_didattica", text: "Sai insegnare la respirazione applicata a salti, pirouette ed equilibri?" },
  { id: 115, area: "pratica_didattica", text: "Utilizzi esercizi di respirazione durante il riscaldamento?" },
  { id: 116, area: "pratica_didattica", text: "Utilizzi esercizi respiratori per migliorare il recupero dopo il lavoro intenso?" },
  // Supporto agli allievi
  { id: 105, area: "supporto_allievi", text: "Sai aiutare un allievo a gestire l'ansia prima di un esame o di uno spettacolo?" },
  { id: 117, area: "supporto_allievi", text: "Sai utilizzare il respiro per aiutare gli allievi nella gestione dell'ansia prima di esami e spettacoli?" },
  { id: 106, area: "supporto_allievi", text: "Ritieni che la respirazione dovrebbe essere parte integrante della formazione del danzatore?" },
  { id: 107, area: "supporto_allievi", text: "Ritieni che la respirazione sia una competenza fondamentale per chi insegna danza?" },
  // Sviluppo professionale
  { id: 108, area: "sviluppo_professionale", text: "Vorresti integrare una metodologia strutturata di respirazione nelle tue lezioni?" },
  { id: 118, area: "sviluppo_professionale", text: "Vorresti integrare nella tua didattica un metodo professionale e certificato come il Metodo BDF?" },
  { id: 109, area: "sviluppo_professionale", text: "Vorresti approfondire il legame tra respirazione, performance e mindset?" },
  { id: 110, area: "sviluppo_professionale", text: "Saresti interessato a integrare un metodo strutturato di respirazione nel tuo lavoro?" },
  { id: 111, area: "sviluppo_professionale", text: "Ti piacerebbe acquisire una certificazione specifica nell'applicazione della respirazione alla danza?" },
  { id: 112, area: "sviluppo_professionale", text: "Quanto è importante per te distinguerti professionalmente come insegnante?" },
];

// ============ ENTRAMBI: tutte le domande ============
const ENTRAMBI_QUESTIONS = [...DANZATORE_QUESTIONS, ...INSEGNANTE_QUESTIONS];

export const QUESTIONS_BY_ROLE = {
  danzatore: DANZATORE_QUESTIONS,
  insegnante: INSEGNANTE_QUESTIONS,
  entrambi: ENTRAMBI_QUESTIONS,
};

// ============ Aree per ruolo (per progress display) ============
export const AREAS_BY_ROLE = {
  danzatore: [
    { id: "consapevolezza", title: "Consapevolezza Respiratoria", subtitle: "Sezione 1 di 4" },
    { id: "performance_recupero", title: "Performance e Recupero", subtitle: "Sezione 2 di 4" },
    { id: "gestione_ansia", title: "Gestione dell'Ansia", subtitle: "Sezione 3 di 4" },
    { id: "applicazione_tecnica", title: "Applicazione Tecnica", subtitle: "Sezione 4 di 4" },
  ],
  insegnante: [
    { id: "pratica_didattica", title: "Pratica Didattica", subtitle: "Sezione 1 di 3" },
    { id: "supporto_allievi", title: "Supporto agli Allievi", subtitle: "Sezione 2 di 3" },
    { id: "sviluppo_professionale", title: "Sviluppo Professionale", subtitle: "Sezione 3 di 3" },
  ],
  entrambi: [
    { id: "consapevolezza", title: "Consapevolezza Respiratoria", subtitle: "Percorso Danzatore · Sezione 1" },
    { id: "performance_recupero", title: "Performance e Recupero", subtitle: "Percorso Danzatore · Sezione 2" },
    { id: "gestione_ansia", title: "Gestione dell'Ansia", subtitle: "Percorso Danzatore · Sezione 3" },
    { id: "applicazione_tecnica", title: "Applicazione Tecnica", subtitle: "Percorso Danzatore · Sezione 4" },
    { id: "pratica_didattica", title: "Pratica Didattica", subtitle: "Percorso Insegnante · Sezione 1" },
    { id: "supporto_allievi", title: "Supporto agli Allievi", subtitle: "Percorso Insegnante · Sezione 2" },
    { id: "sviluppo_professionale", title: "Sviluppo Professionale", subtitle: "Percorso Insegnante · Sezione 3" },
  ],
};

// ============ Obiettivi per ruolo ============
export const OBIETTIVI_BY_ROLE = {
  danzatore: [
    "Migliorare la mia performance",
    "Gestire meglio l'ansia",
    "Migliorare resistenza e recupero",
    "Migliorare presenza scenica",
    "Migliorare equilibrio e controllo",
    "Ottimizzare il recupero fisico",
  ],
  insegnante: [
    "Integrare la respirazione nelle mie lezioni",
    "Aiutare gli allievi nella gestione dell'ansia",
    "Migliorare i risultati degli allievi",
    "Ampliare le mie competenze professionali",
    "Approfondire il Metodo BDF",
  ],
  entrambi: [
    "Migliorare la mia performance",
    "Gestire meglio l'ansia",
    "Migliorare resistenza e recupero",
    "Migliorare presenza scenica",
    "Migliorare equilibrio e controllo",
    "Ottimizzare il recupero fisico",
    "Integrare la respirazione nelle mie lezioni",
    "Aiutare gli allievi nella gestione dell'ansia",
    "Migliorare i risultati degli allievi",
    "Ampliare le mie competenze professionali",
    "Approfondire il Metodo BDF",
  ],
};

// ============ CTA per ruolo ============
export const COURSE_URL = "https://bdfcorsielianabassotto.com/corso-certificato";
export const COACHING_URL = "https://bdfcorsielianabassotto.com/coaching-1%3A1-premium";
export const CALL_URL = "https://calendly.com/elianabassotto-info/30min";

const CALL_SECONDARY = {
  title: "Vuoi confrontarti direttamente con Eliana?",
  text: "Prenota una call strategica gratuita con Eliana Bassotto per capire quale percorso del Metodo BDF è più adatto ai tuoi obiettivi.",
  subtitle: "30 minuti • Nessun impegno • Parlerai direttamente con Eliana Bassotto",
  buttons: [
    { label: "Prenota una call strategica gratuita con Eliana", url: "https://calendly.com/elianabassotto-info/30min" },
  ],
};

const CALL_SECONDARY_WITH_COACHING = {
  ...CALL_SECONDARY,
  buttons: [
    { label: "Prenota una call strategica gratuita con Eliana", url: "https://calendly.com/elianabassotto-info/30min" },
    { label: "Scopri il Coaching del Metodo BDF", url: "https://bdfcorsielianabassotto.com/coaching-1%3A1-premium" },
  ],
};

export const CTAS_BY_ROLE = {
  danzatore: {
    primary: {
      title: "Porta la tua danza al livello successivo",
      text: "Scopri il Corso di Certificazione Metodo BDF Standard e impara ad utilizzare il respiro per migliorare performance, resistenza, controllo ed espressività.",
      button: "Scopri il Corso Metodo BDF Standard",
      url: COURSE_URL,
    },
    secondary: CALL_SECONDARY_WITH_COACHING,
  },
  insegnante: {
    primary: {
      title: "Porta il tuo insegnamento al livello successivo",
      text: "Scopri il Corso di Certificazione Metodo BDF Premium e acquisisci una metodologia strutturata per integrare la respirazione nelle tue lezioni.",
      button: "Scopri il Corso Metodo BDF Premium",
      url: COURSE_URL,
    },
    secondary: CALL_SECONDARY,
  },
  entrambi: {
    primary: {
      title: "Diventa il punto di riferimento nella respirazione applicata alla danza",
      text: "Ottieni la Certificazione Metodo BDF Premium e trasforma la tua competenza in una metodologia riconoscibile, certificata e distintiva.",
      button: "Ottieni la Certificazione Metodo BDF Premium",
      url: COURSE_URL,
    },
    secondary: CALL_SECONDARY,
  },
};

export const RUOLI = [
  { value: "danzatore", label: "Danzatore / Danzatrice" },
  { value: "insegnante", label: "Insegnante di danza" },
  { value: "entrambi", label: "Sono insegnante e pratico anche la danza" },
];

export const STILI_DANZA = [
  "Danza Classica",
  "Danza Contemporanea",
  "Danza Moderna",
  "Jazz",
  "Hip Hop",
  "Danza Caratteri / Folklorica",
  "Danza Aerea",
  "Tango / Danze di coppia",
  "Flamenco",
  "Altro",
];
